import { ActionHandler } from 'action-handler';

export default new ActionHandler({
  name: 'set_deeplink_status',
  stateProp: 'deeplinkStatus',
  defaultState: {
    deeplinkStatus: {
      isOpen: false
    }
  },
  handler(isOpen) {
    return {
      deeplinkStatus: {
        isOpen
      }
    };
  },
  reduce(_, { deeplinkStatus }) {
    return {
      deeplinkStatus
    };
  }
});
